import { subscribeApiEndpoints, versionApiEndpoints } from '@/api/endpoints';
import { ShowAllData, useMutateGetApi } from '@/apiError/apiShow';
import { useFetch } from '@/hooks';
import { enablePaginationOrNot } from '@/utils/common';
import { globalSearch } from '@/utils/search/Search';

import { Button, Card, Col, Input, Row, Table } from 'antd';
import { useEffect, useState } from 'react';
import { CiSearch } from 'react-icons/ci';
import { Link, useNavigate } from 'react-router-dom';
import CreateVerison from './CreateVersion';
import EditVersion from './EditVersion';
import { useVersions } from './hooks/useVersions';
import { DeleteModal } from './deleteModal';

export function VersionList() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [referenceId, setReferenceId] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [data, setData] = useState([]);

  const { data, refetch } = useVersions(navigate);
  const versions = data?.data || [];

  const Column = [
    {
      title: 'S.N',
      dataIndex: 'index',
      align: 'center',
      key: 'index',
      width: 50,
    },
    {
      title: 'Verison Name',
      dataIndex: 'versionName',
      align: 'left',
      key: 'versionName',
    },
    {
      title: 'Price',
      dataIndex: 'price',
      align: 'right',
      key: 'price',
    },
    {
      title: 'Billing Cycle',
      dataIndex: 'billingCycle',
      align: 'left',
      key: 'billingCycle',
    },
    {
      title: 'Action',
      align: 'center',
      width: 100,
      render: (item) => (
        <>
          <div className="ant-action tw-flex tw-gap-6 tw-justify-center">
            <Link size="medium" className="edit">
              <EditVersion id={item.referenceId} refetch={refetch} />
            </Link>
            <div className="ant-button-delete">
              <DeleteModal id={item.referenceId} refetch={refetch} />
            </div>
          </div>
        </>
      ),
    },
  ];

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const { data } = await ShowAllData.showDetails(
  //         '/superadmin/versions/',
  //         navigate,
  //       );
  //       setData(data);
  //     } catch (error) {}
  //   };
  //   fetchData();
  // }, []);
  return (
    <>
      <Card>
        <Row className="mb-4">
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <div className="flex justify-between">
              <CreateVerison refetch={refetch} />
              <div className="flex flex-col items-center justify-center gap-[10px]">
                <Input
                  className="header-search"
                  name="query"
                  placeholder="Search Subscriber..."
                  prefix={<CiSearch />}
                  value={searchQuery}
                  onChange={(event) => setSearchQuery(event.target.value)}
                />
              </div>
            </div>
          </Col>
        </Row>

        <Table
          columns={
            Column
            //   ?.map((col) => ({
            //   ...col,
            //   onCell: () => ({
            //     style: {
            //       padding: '6px 10px',
            //     },
            //   }),
            // }))
          }
          scroll={{ x: true }}
          dataSource={
            versions
              ? globalSearch(versions, searchQuery).map((item, index) => {
                  return {
                    index: index + 1,
                    versionName: item.versionName,
                    price: item.price,
                    billingCycle: item.billingCycle,
                    referenceId: item.referenceId,
                  };
                })
              : []
          }
          bordered
          pagination={false}
        />
      </Card>
    </>
  );
}
